module.exports = __webpack_public_path__ + "img/mass-privilege-active@3x.png";